var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"total-value",style:(_vm.balanceColor)},[_vm._v(" Balance: "+_vm._s(_vm.totalBalance || 0)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }